import type { SerializedError } from '@reduxjs/toolkit';

import { type FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { toast } from 'react-toastify';
import { exportCsvApiSlice } from '../services/exportCSVApiSlice';

interface UseDownloadResult {
  downloadFile: (startDate: string, endDate: string) => Promise<void>;
  isLoading: boolean;
  error: FetchBaseQueryError | SerializedError | undefined;
  isSuccess: boolean;
}

export const useDownloadCSVFile = (): UseDownloadResult => {
  const [trigger, { isLoading, error, isSuccess }] = exportCsvApiSlice.useDownloadCSVFileMutation();

  const downloadFile = async (startDate: string, endDate: string) => {
    try {
      const result: Blob = await trigger({ startDate, endDate }).unwrap();

      const url = window.URL.createObjectURL(result);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `report-${startDate}-to-${endDate}.csv`);
      document.body.appendChild(link);
      link.click();

      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error('Download failed:', err!);
    }
  };

  return {
    downloadFile,
    isLoading,
    error,
    isSuccess,
  };
};
